import { useState, useEffect,useContext } from 'react';
import { Modal } from 'react-bootstrap';
import tableStyle from '../Style/TableModel.module.css';
import formStyle from '../Style/modalForm.module.css';
import button from '../Style/ButtonStyle.module.css';
import { USERS_API_BASE_URL } from './../../constants';
import AuthContext from "../../store/auth-context";
import axios from "axios";
const UploadProfile = (props) => {
    const authCtx = useContext(AuthContext);
    const [userID, setUserID] = useState(0);
    const [usermessage, setUserMessage] = useState('');
    const [selectedFile, setSelectedFile] = useState("");
    const [profileImageUrl, setProfileImageurl] = useState("");

    const http = axios.create({
        baseURL: USERS_API_BASE_URL,
        headers: {
            "Content-type": "application/json",'Authorization':authCtx.token
        }
    });
    const ProfileImageUpdate = (e) => {
        e.preventDefault();
        
        // Validate that an image has been selected and uploaded
        if (!selectedFile && (!profileImageUrl || profileImageUrl.trim() === '')) {
            setUserMessage('Required field missing.');
            return;
        }
        
        // Image is already uploaded, update userData to trigger header refresh
        if (profileImageUrl) {
            authCtx.userData.thumbImage = profileImageUrl;
            authCtx.login(authCtx.userData); // This will trigger re-render in Header
        }
        
        props.setMessage('Profile image updated successfully');
        setUserID(0);
        setSelectedFile("");
        setProfileImageurl("");
        props.onAction(false);
    }

    const onProfileFileChange = async (event) =>{
        event.preventDefault();
        
        // Clear any previous error message
        setUserMessage('');
        
        let formData = new FormData();
        let file = event.target.files[0];
        
        if (!file) {
            return;
        }
        
        setSelectedFile(file);
        formData.append("file", file);
        
        try {
            const response = await http.post("/profile/profile-image/" + userID, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            
            console.log('profileImageUpload response===', response.data);
            
            if (response.data && response.data.thumbUrl) {
                // CDN URL is already complete, no need to prepend
                const imageUrl = response.data.thumbUrl;
                
                console.log('Profile image URL:', imageUrl);
                
                // Update all relevant states
                authCtx.setUProfileImage(imageUrl);
                localStorage.setItem(authCtx.userData.uuid, imageUrl);
                authCtx.userData.thumbImage = imageUrl;
                authCtx.login(authCtx.userData); // Trigger context update for Header
                
                setProfileImageurl(imageUrl);
                props.setProfileImg(imageUrl);
                setUserMessage('Image uploaded successfully. Click Save to finish.');
            } else {
                setUserMessage('Error: Invalid response from server');
                console.error('Invalid response:', response.data);
            }
        } catch (error) {
            console.error('Upload error:', error);
            setUserMessage('Error uploading image: ' + (error.response?.data?.error || error.message));
        }

    }
    useEffect(()=>{
        setUserID(props.userDetail.user.uuid);
    },[props.userDetail])
    //console.log('useridhitesh',userID);
    const ImageThumb = ({ image }) => {
        return <img src={URL.createObjectURL(image)} style={{"width" : "80px","height":"80px"}} alt={image.name} />;
      };
    return (
        <>
            <Modal
                size="lg"
                show={props.modalStatus}
                onHide={props.onAction}
                shouldCloseOnOverlayClick={false} 
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <div className={formStyle.headArea}>
                    <Modal.Title id="example-modal-sizes-title-lg">
                        <h4 className={tableStyle.modalTitle}> Upload Profile</h4>
                    </Modal.Title>
                </div>
                <div className='Modify_PageTitle__VS3pb FontFamily_fontMedium__1Bl7w' style={{"fontSize":14,"color":"red","marginLeft":"15px"}}>{usermessage}</div>
                <form onSubmit={ProfileImageUpdate} >
                <div className={formStyle.bodyArea}>
                    
                        <div className="row">
                            <div className="col-ms-12">
                                
                                <div className={formStyle.group}>
                                <input type="file" id="org-files" onChange={onProfileFileChange} />
                                        {selectedFile && <ImageThumb image={selectedFile} />}
                                        {profileImageUrl && !selectedFile && <img src={profileImageUrl} style={{"width" : "80px","height":"80px"}} alt={profileImageUrl} />}
                                </div>
                                
                                
                            </div>
                        </div>
                    
                </div>
                <div className={formStyle.FooterArea}>
                    <button type="button" onClick={props.onAction} className={button.btn + ' ' + button.brownButton}>Cancel</button>
                    <button type="submit" className={button.btn + ' ' + button.blueButton + ' ' + button.buttonSpaceLeft}>Save</button>  
                </div>
                </form>
            </Modal>
        </>
    )
}
export default UploadProfile;